import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allDowntime }) => {
  if (!allDowntime) return state;
  return state.merge({ allDowntime });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setAllDowntimeCategories = (state, { downtimeCategories }) => {
  return state.merge({ downtimeCategories });
};

const setAllDowntimeCategoriesReason = (state, { downtimeCategoryReasons }) => {
  return state.merge({ downtimeCategoryReasons });
};

const setAllDowntimeReason = (state, { allDowntimeReasonData }) => {
  return state.merge({ allDowntimeReasonData });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL_DOWNTIME_REASON,
    actionFunction: setAllDowntimeReason,
  },
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALL_DOWNTIME_CATEGORIES,
    actionFunction: setAllDowntimeCategories,
  },
  {
    actionType: ActionTypes.SET_ALL_DOWNTIME_CATEGORIES_REASON,
    actionFunction: setAllDowntimeCategoriesReason,
  },
];
